import {Component, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, CF, E, R, FR} from "../_common/layout";
import {CompanyUser} from "../_api";
import {doLogin, fetchUser} from "../_rx/_auth/actions";
import {Link} from 'react-router-dom'
import {Helmet} from "react-helmet";
import {USER_DATA_TITLE, USER_DATA_TITLE_PAGE} from "../constants";

type Props = {loggedUser:CompanyUser, fetchUser:Function};

class View extends Component<Props,{}> {

    render({ loggedUser}:Props) {

        if(!loggedUser) return null;

        return <C className="max-width-780">

            <C className="card p-x2-all m-bottom">
                <Helmet>
                    <title>{USER_DATA_TITLE_PAGE}</title>
                </Helmet>
                <h3 className="no-margin-top">{USER_DATA_TITLE}</h3>

                <div className="detail">
                    <FR>
                        <E className="sm-col-80 col-100">
                            <small>{t('Correo electrónico')}</small> <br/>
                            {loggedUser.email}
                        </E>
                        <E className="sm-col-20 col-100 t-left sm-t-right"> <Link to="/user/email" className="btn btn-ghost">Cambiar</Link> </E>
                        <div className="col-100"> <hr className="separator-xxs"/></div>
                        <E className="sm-col-80 col-100">
                            <small>{t('Contraseña')}</small> <br/>
                            ************
                        </E>
                        <E className="sm-col-20 col-100 t-left sm-t-right"> <Link to="/user/password" className="btn btn-ghost">Cambiar</Link> </E>
                    </FR>
                </div>

            </C>

            <C className="card p-x2-all">
                <h3 className="no-margin-top">Datos de contacto</h3>

                <div className="detail">
                    <R className="row-2-el">
                        <div className="col-80">
                            <small>{t('Nombre y apellidos')}</small> <br/>
                            {loggedUser.name} {loggedUser.surname}
                        </div>
                        <div className="sm-col-80 col-100">
                            <small>{t('Teléfono')}</small> <br/>
                            {loggedUser.phone}
                        </div>
                        <div className="sm-col-20 col-100 t-left sm-t-right"> <Link to="/user/edit" className="btn btn-ghost">Cambiar</Link> </div>
                    </R>
                </div>
            </C>

            {/*<pre>{JSON.stringify(loggedUser,null,'  ')}</pre>*/}
        </C>;
    }
}

const ConnectedView: any = connect(
    ({auth:{loggedUser}}:any)=>({loggedUser}), {fetchUser})(View as any);

export default ({history}: any) =>
    <AppPage
        name="user-profile"
        title={t('Datos de usuario')}
        subtitle=""
        back={() => {history.push('/offers')}}
        className="max-width-780">
        <ConnectedView />

    </AppPage>
;
